/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { DeprecationsEntryPointEntrypointProps } from './DeprecationsEntryPoint.entrypoint.types.tsx';

type DeprecationsEntryPointComponent = EntryPointComponent<
	{},
	{},
	DeprecationsEntryPointEntrypointProps,
	{}
>;

export const deprecationsEntryPoint: EntryPoint<DeprecationsEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<DeprecationsEntryPointComponent>(
			/* webpackChunkName: "async-itam-settings-hardware-deprecations" */ './DeprecationsContent.tsx',
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	});
